/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceDefinitionRecordsInner } from './ServiceDefinitionRecordsInner';
import {
    ServiceDefinitionRecordsInnerFromJSON,
    ServiceDefinitionRecordsInnerFromJSONTyped,
    ServiceDefinitionRecordsInnerToJSON,
} from './ServiceDefinitionRecordsInner';

/**
 * 
 * @export
 * @interface ServiceDefinition
 */
export interface ServiceDefinition {
    /**
     * 
     * @type {Array<ServiceDefinitionRecordsInner>}
     * @memberof ServiceDefinition
     */
    records?: Array<ServiceDefinitionRecordsInner>;
}

/**
 * Check if a given object implements the ServiceDefinition interface.
 */
export function instanceOfServiceDefinition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceDefinitionFromJSON(json: any): ServiceDefinition {
    return ServiceDefinitionFromJSONTyped(json, false);
}

export function ServiceDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ServiceDefinitionRecordsInnerFromJSON)),
    };
}

export function ServiceDefinitionToJSON(value?: ServiceDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ServiceDefinitionRecordsInnerToJSON)),
    };
}

